/* WD Electronics, article enhancements: table of contents, scroll-spy,
   reading progress, heading anchors, copy-link. Vanilla, scoped, idempotent. */
(function () {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var currentScroll = null;

  function slugify(str) {
    return (str.toLowerCase().trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-+|-+$/g, '')) || 'section';
  }

  function init(root) {
    var article = (root || document).querySelector('[data-wd-article]');
    if (!article || article.dataset.wdInit === '1') return;
    article.dataset.wdInit = '1';

    var content = article.querySelector('.js-wd-content');
    var tocNav = article.querySelector('.js-wd-toc');
    var tocMobile = article.querySelector('.js-wd-toc-mobile');
    var progress = document.querySelector('.js-wd-progress');

    /* ---- Build the table of contents from real headings ---- */
    var headings = content ? Array.prototype.slice.call(content.querySelectorAll('h2, h3')) : [];
    headings = headings.filter(function (h) {
      return !h.closest('.accordian, .js__accordian, details, .accordion-section') && (h.textContent || '').trim();
    });

    var used = {};
    var links = headings.map(function (h) {
      var text = h.textContent.trim();
      var id = h.id;
      if (!id) {
        id = slugify(text);
        if (used[id]) { used[id] += 1; id = id + '-' + used[id]; } else { used[id] = 1; }
        h.id = id;
      }
      if (!h.querySelector('.wd-anchor')) {
        var anchor = document.createElement('a');
        anchor.className = 'wd-anchor';
        anchor.href = '#' + id;
        anchor.textContent = '#';
        anchor.tabIndex = -1;
        anchor.setAttribute('aria-hidden', 'true');
        h.insertBefore(anchor, h.firstChild);
      }
      return { id: id, text: text, level: h.tagName === 'H3' ? 3 : 2 };
    });

    function buildList(ul) {
      var made = [];
      if (!ul) return made;
      links.forEach(function (l) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + l.id;
        a.textContent = l.text;
        if (l.level === 3) a.className = 'is-sub';
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var target = document.getElementById(l.id);
          if (target) {
            target.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
            if (history.replaceState) history.replaceState(null, '', '#' + l.id);
          }
          if (tocMobile && tocMobile.open) tocMobile.open = false;
        });
        li.appendChild(a);
        ul.appendChild(li);
        made.push({ id: l.id, a: a });
      });
      return made;
    }

    var desktopLinks = buildList(article.querySelector('.js-wd-toc-list'));
    var mobileLinks = buildList(article.querySelector('.js-wd-toc-list-mobile'));

    if (links.length >= 2) {
      if (tocNav) tocNav.hidden = false;
      if (tocMobile) tocMobile.hidden = false;
      var layout = article.querySelector('.wd-article__layout');
      if (layout) layout.classList.add('wd-article__layout--toc');
    }

    /* ---- Reading progress + scroll-spy (single rAF loop) ---- */
    function setActive(list, id) {
      list.forEach(function (item) {
        item.a.classList.toggle('is-active', item.id === id);
      });
    }

    var ticking = false;
    function update() {
      ticking = false;
      if (progress) {
        var measure = content || article;
        var rect = measure.getBoundingClientRect();
        var total = measure.offsetHeight - window.innerHeight;
        var scrolled = total > 0 ? Math.min(Math.max(-rect.top / total, 0), 1) : (rect.top < 0 ? 1 : 0);
        progress.style.width = (scrolled * 100).toFixed(2) + '%';
      }
      if (links.length) {
        var offset = 120;
        var activeId = links[0].id;
        for (var i = 0; i < headings.length; i++) {
          if (headings[i].getBoundingClientRect().top - offset <= 0) activeId = links[i].id;
          else break;
        }
        setActive(desktopLinks, activeId);
        setActive(mobileLinks, activeId);
      }
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    if (currentScroll) {
      window.removeEventListener('scroll', currentScroll);
      window.removeEventListener('resize', currentScroll);
    }
    currentScroll = onScroll;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();

    /* ---- Copy link ---- */
    var copyBtn = article.querySelector('.js-wd-copy');
    if (copyBtn && navigator.clipboard) {
      copyBtn.addEventListener('click', function () {
        navigator.clipboard.writeText(copyBtn.getAttribute('data-url') || window.location.href).then(function () {
          var prev = copyBtn.textContent;
          copyBtn.textContent = 'Copied';
          setTimeout(function () { copyBtn.textContent = prev; }, 1600);
        }).catch(function () {});
      });
    }
  }

  function boot() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
